import { Component } from '@angular/core';

@Component({
  selector: 'app-page-banner-showcase',
  templateUrl: './page-banner-showcase.component.html',
  styleUrls: ['./page-banner-showcase.component.scss']
})
export class PageBannerShowcaseComponent {}
